"use client";

import * as React from "react";
import Image from "next/image";

export function CustomLogo({ src = "/AseedLogo.svg", alt = "Aseed", width = 100, height = 100, ...props }: Omit<React.ImgHTMLAttributes<HTMLImageElement>, "src"> & { src?: string }) {
  return (
    <Image
      unoptimized
      src={src}
      alt={alt}
      width={Number(width)}
      height={Number(height)}
      {...props}
    />
  );
}
